import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// import SearchInputsComponent from '../../components/etmTickets/searchInputs'
import TicketsTableComponent from '../../components/etmTickets/ticketsTable'

import * as actions from './actions'

import './styles.css'
import { opdbGTM } from '../../utils/pulseUtils'

class TripDetailsContainer extends React.Component {

  state = {};

  componentDidMount() {
    this.props.getTicketDetails(this.props.match.params.tripId);
    opdbGTM.tabClicked('od_etm_tab_clicked')
  }

  render() {
    const { ticketDetails } = this.props;
    return (
      <div className="manage-user-wrp">
        <div className="row payout-header">
          <span className="payout-header-text">Ticket Details</span>
        </div>
        <TicketsTableComponent
          tableData={ticketDetails}
        />
      </div>
    )
  }
}


const mapStateToProps = store => ({
  ticketDetails: store.etmTicketsReducer.ticketDetails,
})

const mapDispatchToProps = dispatch => ({
  getTicketDetails: (tripId) => dispatch(actions.getTicketDetails(tripId)),
})

TripDetailsContainer.propTypes = {
  ticketDetails: PropTypes.array.isRequired,
  getTicketDetails: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(TripDetailsContainer)
